<script>
    export let averages = false;
    export let league = "nba";
    export let is_goalie = false;
    import { afterUpdate } from 'svelte';
    function roundToTenth(number) {
        //check if number is a number
        if (isNaN(number)) {
            return "";
        }
        return number.toFixed(1);
    }
    function destroyTooltips() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl).dispose();
        })
    }
    function enableTooltips() {
        //run after .5 seconds
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })
    }
    function reInitTooltips() {
        destroyTooltips();
        enableTooltips();
    }
    afterUpdate(() => {
		reInitTooltips();
	});
</script>
<h4 class="m-0">Season Stats
    {#if averages}
    <small class="text-muted"> - {roundToTenth(averages['fantasy points'])} FP</small>
    {/if}
</h4>
<div class="border rounded-2 w-100 row mx-0 my-1">
    {#if league == "nba"}
    <div class="border-end col-sm-2 col-4 p-1 text-center" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-html="true" title="
    <div>FG {roundToTenth(parseInt(averages['two_point_fgm'])+parseInt(averages['three_point_fgm']))} / {roundToTenth(parseInt(averages['two_point_fga'])+parseInt(averages['three_point_fga']))}</div>
    <div>3FG {roundToTenth(averages['three_point_fgm'])} / {roundToTenth(averages['three_point_fga'])}</div>
    <div>FT {roundToTenth(averages['ftm'])} / {roundToTenth(averages['fta'])}</div>">
        <div class="fw-bold">PTS</div>
        <div>{roundToTenth(averages['points'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">REB</div>
        <div>{roundToTenth(averages['rebounds'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">AST</div>
        <div>{roundToTenth(averages['assists'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">STL</div>
        <div>{roundToTenth(averages['steals'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">BLK</div>
        <div>{roundToTenth(averages['blocks'])}</div>
    </div>
    <div class="col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">TO</div>
        <div>{roundToTenth(averages['turnovers'])}</div>
    </div>
    {:else if league == "nhl" && is_goalie}
    <div class="border-end col-sm-3 col-6 p-1 text-center">
        <div class="fw-bold">SV</div>
        <div>{roundToTenth(averages['saves'])}</div>
    </div>
    <div class="border-end col-sm-3 col-6 p-1 text-center">
        <div class="fw-bold">GA</div>
        <div>{roundToTenth(averages['goals_against'])}</div>
    </div>
    <div class="border-end col-sm-3 col-6 p-1 text-center">
        <div class="fw-bold">SV%</div>
        <div>{averages['shots_against'] > 0 ? (averages['saves'] / averages['shots_against']).toFixed(3) : ""}</div>
    </div>
    <div class="col-sm-3 col-6 p-1 text-center">
        <div class="fw-bold">W%</div>
        <div>{isNaN(averages['wins']) ? "" : Math.round(averages['wins'] * 100) + "%"}</div>
    </div>
    {:else if league == "nhl"}
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">G</div>
        <div>{roundToTenth(averages['goals'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">A</div>
        <div>{roundToTenth(averages['assists'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">PTS</div>
        <div>{roundToTenth(averages['points'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">SOG</div>
        <div>{roundToTenth(averages['shots on goal'])}</div>
    </div>
    <div class="border-end col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">BLK</div>
        <div>{roundToTenth(averages['blocked shots'])}</div>
    </div>
    <div class="col-sm-2 col-4 p-1 text-center">
        <div class="fw-bold">TOI</div>
        <div>{roundToTenth(averages['time_on_ice'])}</div>
    </div>
    {/if}
</div>